import { request } from './request';
import { Webhook, WebhookPayload } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';

export const loadWebhooks = (limit?: number, offset?: number): Promise<Webhook[]> => {
    const { Webhooks } = request();
    return Webhooks.webhooksGet(limit, offset).then((resp) => resp.data);
};
export const addWebhook = (newWebhook: WebhookPayload): Promise<Webhook> => {
    const { Webhooks } = request();
    return Webhooks.webhooksPost(newWebhook).then((resp) => resp.data);
};
export const deleteWebhook = (publicid: string): AxiosPromise<void> => {
    const { Webhooks } = request();
    return Webhooks.webhooksByPublicidDelete(publicid);
};
export const updateWebhook = (publicid: string, webhook: WebhookPayload): Promise<Webhook> => {
    const { Webhooks } = request();

    return Webhooks.webhooksByPublicidPut(publicid, webhook).then((resp) => resp.data);
};
